/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Vchip_Content_DescriptionInputs */



/**
* | output |
* | --- |
* | "Content Description" |
*
* @param {Subtitle_Export_Vchip_Content_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_vchip_content_description = /** @type {((inputs?: Subtitle_Export_Vchip_Content_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Vchip_Content_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Description du contenu")
	if (locale === "de") return /** @type {LocalizedString} */ ("Inhaltsbeschreibung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Descrizione del contenuto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Описание содержимого")
	if (locale === "es") return /** @type {LocalizedString} */ ("Descripción del contenido")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("内容描述")
	if (locale === "ja") return /** @type {LocalizedString} */ ("コンテンツの説明")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सामग्री का विवरण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Descrição do conteúdo")
	return /** @type {LocalizedString} */ ("Content Description")
});